<template>
  <div id="app">
    <!-- <h1>Graph Calculation</h1> -->
    <GraphLayout />
    <Query />
  </div>
</template>

<script>
import GraphLayout from "./components/GraphLayout.vue";
import Query from "./components/Query.vue";

export default {
  name: "App",
  components: {
    GraphLayout,
    Query,
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  margin-top: 30px;
}

h1 {
  margin: 0px;
  color: rgb(172, 172, 172);
  font-weight: 400;
  font-size: 24px;
}

body {
  background-color: black;
  font-family: Avenir;
}

.links line {
  /* stroke: rgb(119, 119, 119); */
  stroke-opacity: 1;
}

.nodes circle {
  stroke: rgb(114, 114, 114);
  stroke-width: 1px;
  /* fill: rgb(196, 196, 196); */
}

svg {
  margin-top: 20px;
  margin-left: 20px;
  background-color: black;
  border: 1px solid rgb(44, 44, 44);
  border-radius: 20px;
}

text {
  fill: rgb(228, 228, 228, 0.4);
  font-family: sans-serif;
  font-size: 11px;
}

tspan {
  fill: rgba(255, 255, 255, 1);
}

/* .box {
  box-sizing: border-box;
  border: 1px solid pink;
  width: 30px;
  height: auto;
} */
</style>
